module.exports = __webpack_public_path__ + "img/9.504118c5.jpg";